import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { CompanyType, UserType } from '@app/shared/enums';
import { AuthService } from './auth.service';

type ResourceAccess = 'resource-admin' | 'technician';

//Checks which job pages the user can access: Resource Admin pages require a SELF company; 
// FastClosedown requires an Internal/External technician without SELF or City Admin access. 
// Denied users redirect silently to /.
function resourceAccessGuard(access: ResourceAccess): CanActivateFn {
  return async () => {
    const authService = inject(AuthService);
    const router = inject(Router);
    const user = await authService.getUser();
    if (!user || !Array.isArray(user.companies)) {
      return router.createUrlTree(['/']);
    }

    const isResourceAdmin = user.companies.some(company => company.companyType === CompanyType.SELF);
    let allowed = isResourceAdmin;
    if (access === 'technician') {
      const roles = await authService.getUserRoles();
      allowed = !isResourceAdmin && user.companies.length > 0 &&
        !roles.includes(UserType.CITY_ADMIN) &&
        (roles.includes(UserType.INTERNAL_USER) || roles.includes(UserType.EXTERNAL_USER));
    }

    if (allowed) {
      return true;
    }

    return router.createUrlTree(['/']);
  };
}

export const resourceAdminGuard: CanActivateFn = resourceAccessGuard('resource-admin');
export const technicianGuard: CanActivateFn = resourceAccessGuard('technician');
